import { Card, CardContent, Grid, Paper, Typography } from '@material-ui/core';
import { navigate } from 'gatsby';
import React, { FunctionComponent } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { useIsMobile } from '../../../util/style-utils';
import PGEButton from '../../buttons';
import useStyles from '../styles';
import ROUTES from '../../../routes';

interface TimeOfDaySpecialHandlingProps {
  path?: string;
}
const TimeOfDaySpecialHandling: FunctionComponent<TimeOfDaySpecialHandlingProps> = props => {
  const { t, richT } = useTranslation();
  const classes = useStyles();
  const isMobile = useIsMobile();
  return (
    <Grid container spacing={3} style={{ marginTop: '1em' }}>
      <Grid item>
        <Paper component={'main'} style={{ justifyContent: 'flex-start' }}>
          <Card>
            <CardContent>
              <Grid item xs={12} style={{ marginBottom: '1em' }}>
                <Typography variant={'h2'}>
                  {t('UNABLE_TO_PROCESS_TOD')}
                </Typography>
              </Grid>
              <Grid item xs={12} style={{ marginBottom: '1em' }}>
                <Typography variant={'h6'} component={'div'}>
                  {richT('TOD_UNABLE_PROCESS_ENROLLMENT_ONLINE', {
                    CUSTOMER_SERVICE_NUMBER: t('PGE_CUSTOMER_SERVICE_NUMBER'),
                  })}
                </Typography>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justify={isMobile ? 'center' : 'flex-end'}
                spacing={1}
                wrap="wrap-reverse"
              >
                <Grid item xs={10} md="auto">
                  <PGEButton
                    fullWidth
                    onClick={async () => {
                      await navigate(ROUTES.ACCOUNT);
                    }}
                  >
                    <Typography variant={'h4'} noWrap>
                      {t('DONE')}
                    </Typography>
                  </PGEButton>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </Grid>
    </Grid>
  );
};
export default TimeOfDaySpecialHandling;
